import axios from 'axios';
import { useEffect, useState } from 'react';
import { USERAPI } from '../const';
import { getNombresRoles } from './hooks';

const UserInfo = ({ usuario = null }) => {
  const [datosUsuarioLogueado, setDatosUsuarioLogueado] = useState({});
  useEffect(() => {
    if (!datosUsuarioLogueado.nombre) {
      axios
        .get(`${USERAPI}/usuarios`, {
          headers: {
            Authorization: `Bearer ${usuario?.token}`,
          },
        })
        .then((res) => {
          setDatosUsuarioLogueado(res.data);
        })
        .catch((error) => {
          if (error.response) {
            // Request made and server responded
            console.log(error.response.data.message);
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log(error.message);
          }
        });
    }
  });
  if (datosUsuarioLogueado.idUsuario) {
    return (
      <h6>
        <small className="text-muted">
          {datosUsuarioLogueado.nombre} {datosUsuarioLogueado.apellido} /{' '}
          {getNombresRoles(datosUsuarioLogueado.roles)}
        </small>
      </h6>
    );
  } else {
    return <></>;
  }
};

export default UserInfo;
